import {
    FETCH_BENCHMARK_KPI_TILES_START,
    FETCH_BENCHMARK_KPI_TILES_SUCCESS,
    FETCH_BENCHMARK_KPI_TILES_FAIL,

} from "../../../constants";
import {
    FETCH_BENCHMARK_KPI_TILES_URL,
} from "../../../../../config/constants";
import { createVisualizationFetchAction } from "./createVisualizationFetchAction";

export const getBenchmarkKpiTiles = createVisualizationFetchAction(FETCH_BENCHMARK_KPI_TILES_URL, {
    START: FETCH_BENCHMARK_KPI_TILES_START,
    SUCCESS: FETCH_BENCHMARK_KPI_TILES_SUCCESS,
    FAIL: FETCH_BENCHMARK_KPI_TILES_FAIL,
});
